let enumValue = 0

const LogLevel = {
    ERROR: {
        label: 'ERROR',
        value: enumValue++
    },
    WARN: {
        label: 'WARN',
        value: enumValue++
    },
    INFO: {
        label: 'INFO',
        value: enumValue++
    },
    DEBUG: {
        label: 'DEBUG',
        value: enumValue++
    },
    TRACE: {
        label: 'TRACE',
        value: enumValue++
    },
    OFF: {
        value: enumValue++
    }
}

LogLevel.fromString = function (value) {
    value = (value || '').toUpperCase()

    if (!value) {
        return LogLevel.OFF
    }

    return LogLevel[value] || LogLevel.OFF
}

export default LogLevel